<template>
  <RouterLink :to="to" class="author title-small-regular">
    <i class="fa-kit fa-sv-author-pen author-icon"></i>
    Auteur
  </RouterLink>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});

const to = computed(() => `/stakeholders/${props.id}/preview`);
</script>

<style lang="scss" scoped>
.author {
  display: flex;
  flex-direction: row;
  gap: 2px;
  color: var(--clr-service-author);
  font-weight: normal;

  &:hover {
    color: var(--clr-author-link-hover);
  }

  &:active {
    color: var(--clr-author-link-pressed);
  }

  i {
    font-size: 1.188rem;
  }

  &:focus-visible {
    box-shadow: 0 0 5px 2px #a802e3;
    outline: 2px solid #a802e3;
    border-radius: 4px;
    padding: 4px 2px;
  }
}
</style>
